import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateTvBrandDocument } from './update.generated';

export const useUpdateTVBrand = (options: ApiOptions<typeof UpdateTvBrandDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(UpdateTvBrandDocument, {
    ...useNotifications(UpdateTvBrandDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.tv_brands.update_success'),
    }),

    ...options,
  });
};
